import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Notif.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { NOTIFICATION_NODE_DESCRIPTION, NodeTypes } from '../../utils';

export const NotificationNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Notification' description={NOTIFICATION_NODE_DESCRIPTION} nodeType={NodeTypes.NOTIFICATION} imgPath={stepIcon} />
}